/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, {css} from 'styled-components';
import {FontWeight, Text} from '../Text';
import Colors from '../../constants/Colors';
import {mediaHelper} from 'utils';
import {Breakpoints} from "../../constants/Breakpoints";

const fontStyleMixin = css`
  color: ${Colors.WHITE};
  font-weight: ${FontWeight.Bold};
`;

const TabList = styled.ul`
  margin: 0 0 24px;
  padding: 0px 10px 0px 10px;
  text-align: center;
  
  @media (min-width: ${Breakpoints.lg}) {
    padding: 0;
    text-align: unset;
  }
`;

const TabList2 = styled.ul`
  margin: 0 0 0;
  padding: 0;
  text-align: center;
  
  @media (min-width: ${Breakpoints.lg}) {
    text.align: unset;
  }
`;

const TabItem = styled.li`
  margin: 10px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 75px;
  padding: 0 16px;
  opacity: 0.8;
  border: 1px solid transparent;
  border-radius: 16px;
  cursor: pointer;

  transition: opacity 0.15s ease, border 0.25s ease;

  ${mediaHelper.sm`
    flex-direction: row;
  `}

  &:hover:not(:disabled) {
    opacity: 1;
    border: 1px solid ${Colors.WHITE};
  }

  & + & {
    margin-left: 24px;
  }
  
  @media (min-width: ${Breakpoints.md}) {
    display: inline-flex;
    margin: unset;
  }
  
  @media (min-width: ${Breakpoints.xxs}) {
    height: 64px;
  }
  
  ${({ isActive }) => isActive && activeTabMixin}
  ${({ visited }) => visited && visitedTabMixin}
`;

const TabItemStep = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-right: 16px;
  border: 1px solid ${Colors.WHITE};
  border-radius: 50%;
  background-color: transparent;
  font-size: 12px;
  margin: auto;
  
  @media (min-width: ${Breakpoints.md}) {
    margin: unset;
  }

  ${fontStyleMixin}
`;

const TabItemTitle = styled(Text)`
 // display: none;
  font-size: 12px;
  text-transform: uppercase;
  
  ${mediaHelper.xxs`
    text-align: center
  `}

  ${mediaHelper.sm`
    display: block;
  `}

  ${fontStyleMixin}
`;

const activeTabMixin = css`
  opacity: 1;
  background-color: ${Colors.WHITE};
  box-shadow: 0px 8px 6px rgba(0, 0, 0, 0.1);

  ${TabItemStep} {
    border: 1px solid transparent;
    background-color: ${Colors.Alpha(Colors.SECONDARY, 0.7)};
    color: ${Colors.PRIMARY};
  }

  ${TabItemTitle} {
    display: block;
    color: ${Colors.PRIMARY};
  }
`;

const visitedTabMixin = css`
  opacity: 1;

  ${TabItemStep} {
    background-color: ${Colors.WHITE};
    color: ${Colors.Alpha(Colors.PRIMARY, 0.7)};
  }
`;

export { TabList, TabList2, TabItem, TabItemStep, TabItemTitle };
